import React from "react";
export const colHeaders = [
  " ",
  "Prior Day",
  "Daily Need",
  "% Daily Need",
  "Total MTD",
  "Forecast",
  "Monthly Goal",
  "% Goal"
];

export const limitedColHeaders = [" ", "Prior Day", "Total MTD"];

export const applyColor = (rawValue) => {
  let color = "";
  if (rawValue >= 1) {
    color = "green";
  } else if (0.9 <= rawValue && rawValue < 1) {
    color = "grey";
  } else {
    color = "red";
  }
  return color;
};

export const addGaps = (data, links) => {
  const gap = [" ", " ", " ", " ", " ", " ", " ", " "];
  data.unshift(gap);
  data.push(gap);
  links.unshift(null);
  links.push(null);
};

export const customFn = (header, value, rawValue) => {
  if (header === "% Daily Need" || header === "% Goal") {
    return value === "-" ? "-" : <div style={{ color: applyColor(rawValue) }}>{value}</div>;
  }
  return value;
};
